import { render, staticRenderFns } from "./PantallaAlertas.vue?vue&type=template&id=17a202f6&"
import script from "./PantallaAlertas.vue?vue&type=script&lang=ts&"
export * from "./PantallaAlertas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('17a202f6', component.options)
    } else {
      api.reload('17a202f6', component.options)
    }
    module.hot.accept("./PantallaAlertas.vue?vue&type=template&id=17a202f6&", function () {
      api.rerender('17a202f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/InformeAlertas/PantallaAlertas.vue"
export default component.exports